<template>
  <div class="buyer-pending-page">
    <div class="buyer-pending-page-top">
      <BuyerSectionItem
      :icon="this.icon"
      :title="this.title"
      :description="this.description"
      :shouldReturnToTheBuyerPage="true"
    />
    </div>

    <div class="buyer-pending-page-content">
      <FilterSidebarInPendingItems />
    </div>
  </div>
</template>

<script>
import BuyerSectionItem from "@/views/buyer/components/BuyerSectionItem";
import FilterSidebarInPendingItems from "@/views/buyer/components/FilterSidebar/components/FilterSidebarInPendingItems.vue";
import { BUYER_SECTION_PENDING } from "@/views/buyer/constants/BuyerSections";
import { mapMutations } from "vuex";
import { BUYER } from "@/constants/Buyer";

export default {
  name: "BuyerPendingPage",
  components: { BuyerSectionItem, FilterSidebarInPendingItems },
  data: function () {
    return {
      ...BUYER_SECTION_PENDING,
    };
  },
  methods: {
    ...mapMutations("buyer", [
        "setTitleSectionPage",
        "setTitlePage",
        "setSubTitlePage"
    ]),
  },
  mounted() {
    this.setTitleSectionPage(BUYER.TITLE_DASHBOARD);
    this.setTitlePage("Pendentes");
    this.setSubTitlePage("");
  },
};
</script>

<style scoped>
.buyer-pending-page {
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
}

.buyer-pending-page-top {
  width: 100%;
}

.buyer-pending-page-content {
  margin-top: 4px;
  background-color: white;
}
</style>
